import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const SelectFieldGroup = ({
  name,
  placeholder,
  value,
  label,
  error,
  info,
  options,
  type,
  className,
  onChange,
  disabled,
  ChildComponent,
}) => {
  return (
    <div className={classnames(`form-group u-pb-small ${className && className}`, { 'has-error': error })}>
      {label && <label className="c-field__label">{label}</label>}
      <div className="">
        <select
          style={{ height: 40 }}
          className={classnames('form-control')}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
        >
          <option value="">Select One</option>
          {options
            ? options.map(item => (
                <option key={item.key} value={item.key}>
                  {ChildComponent && <ChildComponent />}
                  {!ChildComponent && item.title}
                </option>
              ))
            : null}
        </select>
      </div>
      {info && (
        <small className="c-field__message">
          <i className="fa fa-info-circle"></i>
          {info}
        </small>
      )}
      {error && (
        <small className="c-field__message u-color-danger">
          <i className="fa fa-times-circle"></i> {error}
        </small>
      )}
    </div>
  )
}

SelectFieldGroup.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  ChildComponent: PropTypes.node,
  // value : PropTypes.string,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  info: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  className: PropTypes.any,
}

SelectFieldGroup.defaultProps = {
  type: 'text',
  options: { '': 'Select One' },
  value: '',
}
export default SelectFieldGroup
